import React from "react";
import PropTypes from "prop-types";
import cn from "./style.module.scss";

export function TitleBlock(props) {
  const className = `${cn.wrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

TitleBlock.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

TitleBlock.defaultProps = {
  children: undefined,
  className: "",
};
